import { useEffect, useState } from 'react'

import { useTranslation } from '@/shared/hooks/useTranslation'
import { Button } from '@/shared/ui/Button'

import { AUTO_RESTART_SECONDS, nextCountdownValue } from '../model/celebrationCountdown'

import type { UniquenessPolicy } from '../model/types'

type QuestDoneCelebrationProps = {
  uniquenessPolicy: UniquenessPolicy
  autoRestart: boolean
  onRestart: () => void
}

export function QuestDoneCelebration({
  uniquenessPolicy,
  autoRestart,
  onRestart
}: QuestDoneCelebrationProps) {
  const { t } = useTranslation()
  const [secondsLeft, setSecondsLeft] = useState(AUTO_RESTART_SECONDS)

  useEffect(() => {
    if (!autoRestart) return undefined
    if (secondsLeft <= 0) {
      onRestart()
      return undefined
    }

    const timer = setTimeout(() => setSecondsLeft(nextCountdownValue), 1000)
    return () => clearTimeout(timer)
  }, [autoRestart, secondsLeft, onRestart])

  return (
    <div className="flex flex-col items-center gap-3 text-center">
      <p className="m-0 text-lg font-bold text-gray-900">{t('quests.done.title')}</p>
      <p className="m-0 text-sm text-gray-600">{t('quests.done.thanks')}</p>
      <p className="m-0 text-xs text-gray-500">
        {uniquenessPolicy === 'email' ? t('quests.done.pickupEmail') : t('quests.done.pickupCpf')}
      </p>

      {autoRestart ? (
        <Button variant="ghost" size="sm" onClick={onRestart}>
          {t('quests.done.nextPlayer', { seconds: secondsLeft })}
        </Button>
      ) : (
        <Button variant="primary" size="md" onClick={onRestart}>
          {t('quests.done.restart')}
        </Button>
      )}
    </div>
  )
}
